import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BCollapse } from "bootstrap-vue";
import slugify from "slugify";
import { computed } from "vue";
import { useToolTrainingMaterial } from "@/composables/toolTrainingMaterial";
import { useUid } from "@/composables/utils/uid";
import Heading from "@/components/Common/Heading.vue";
import ExternalLink from "@/components/ExternalLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolTutorialRecommendations',
    props: {
        name: null,
        id: null,
        version: null,
        owner: null
    },
    setup(__props) {
        const props = __props;
        library.add(faCaretDown);
        const { trainingAvailable, trainingCategories, tutorialDetails, allTutorialsUrl, versionAvailable } = useToolTrainingMaterial(props.id, props.name, props.version, props.owner);
        const collapseId = useUid("collapse-");
        function idForCategory(category) {
            return `${collapseId.value}-${slugify(category)}`;
        }
        function tutorialsInCategory(category) {
            return tutorialDetails.value.filter((tut) => tut.category === category);
        }
        const tutorialText = computed(() => {
            if (tutorialDetails.value.length > 1) {
                return `There are ${tutorialDetails.value.length} tutorials available which use this tool.`;
            }
            else {
                return "There is 1 tutorial available which uses this tool.";
            }
        });
        return { __sfc: true, props, trainingAvailable, trainingCategories, tutorialDetails, allTutorialsUrl, versionAvailable, collapseId, idForCategory, tutorialsInCategory, tutorialText, FontAwesomeIcon, BButton, BCollapse, Heading, ExternalLink };
    }
});
